<template>
  <div>
    <modal :show.sync="modals.infoModal" :preventClose="true">
      <div style="
          margin: -24px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #15b0cf;
        ">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-6 text-center">
            <div style="
                text-align: center;
                border-radius: 100%;
                border: 10px solid white;
              ">
              <i style="
                  padding: 15px;
                  color: white;
                  font-size: 130px;
                  font-weight: 900;
                " class="fa fa-info"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Info!
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center">
          <p style="color: #A5A5A5">{{ message }}</p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center" style="margin-bottom: 30px">
          <base-button type="primary" v-on:click="modals.infoModal = false">Ok</base-button>
        </div>
      </div>
    </modal>
    <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle"  />

    <modal :show.sync="modals.cancelModal" :preventClose="true">
      <div style="
          margin: -24px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #cf6a15;
        ">
        <div class="row">
          <div class="col-lg"></div>

          <div class="col-lg-6 text-center">
            <div style="
                text-align: center;
                border-radius: 100%;
                border: 10px solid white;
              ">
              <i style="
                  padding: 15px;
                  color: white;
                  font-size: 130px;
                  font-weight: 900;
                " class="fa fa-question"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Are you sure?
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center">
          <p style="color: #A5A5A5">All changes will not be updated.</p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-6 text-right" style="margin-bottom: 30px">
          <base-button type="danger" v-on:click="modals.cancelModal = false">Cancel</base-button>
        </div>
        <div class="col-lg-6 text-left" style="margin-bottom: 30px">
          <base-button type="primary" v-on:click="redirect()">Continue</base-button>
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.failedModal" :preventClose="true">
      <div style="
          margin: -24px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #EC1B23;
          text-align: center;
        ">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-6 text-center">
            <div style="
                text-align: center;
                border-radius: 100%;
                border: 10px solid white;
              ">
              <i style="
                  padding: 15px;
                  color: white;
                  font-size: 130px;
                  font-weight: 900;
                " class="fa fa-exclamation"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Error
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center">


          <p style="color: #A5A5A5">{{ message }}</p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <p style="color: #A5A5A5; margin-top: 20px">Click 'Retry' to go back.</p>

          <base-button type="danger" v-on:click="getBack()">Exit</base-button>&nbsp;
          <base-button type="primary" v-on:click="closeFailedModal()">Retry</base-button>
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.warningModal" :preventClose="true">
      <div class="modal-header" style="
          margin: -25px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #e5c513;
        ">
        <div class="col-lg"></div>
        <div class="col-lg-5">
          <div style="
              padding: 15px;
              background-color: transparent;
              border-radius: 100px;
              border: 10px solid white;
              text-align: center;
            ">
            <i style="color: white; font-size: 90px; font-weight: 900" class="fa fa-exclamation"></i>
          </div>
          <div>
            <p style="
                color: white;
                font-size: 17px;
                text-align: center;
                font-weight: 500;
              ">
              Warning
            </p>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="col-lg-12 text-center">
        <p style="
            margin-top: 50px;
            font-size: 40px;
            font-weight: 500;
            color: #707070;
          ">
          Are you sure?
        </p>

        <p style="color: #A5A5A5">You won't be able to revert this!</p>

        <p style="color: #A5A5A5; margin-top: 20px">
          Click 'Continue' to proceed to login page
        </p>
        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <base-button class="btn-cancel" v-on:click="cancelPersonnel()">Cancel</base-button>
          <base-button type="primary" v-on:click="deletePersonnel()">Continue</base-button>
        </div>
      </div>
    </modal>
    <base-button style="font-size: 18px" @click="getBack()" class="btn-link">
      &lt; Back
    </base-button>
    <!-- <p
      :style="{ color: colors.primary }"
      style="font-size: 18px"
      @click="getBack()"
    >
      &lt; Back
    </p> -->
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px"></div>

    <div class="col-lg-12">
      <div class="row scrollable-row">
        <div class="col-lg-6 d-flex">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  EXECUTION TEAM DETAILS
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">User name <span style="color: #EC1B23;">*</span></p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="fullname" :class="{ 'custom-input': true }" :disabled="preview" />
                  <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                    {{ fullnameerrormsg }}
                  </p>
                </div>

                <br />
                <p style="color: #A5A5A5">Staff ID <span style="color: #EC1B23;">*</span></p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="staffid" :class="{ 'custom-input': true }" :disabled="preview" />
                  <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                    {{ staffiderrormsg }}
                  </p>
                </div>

                <br />
                <p style="color: #A5A5A5">Phone No. <span style="color: #EC1B23;">*</span></p>
                <div style="padding-right: 30px">
                  <input type="number" v-model="phoneno" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                  <p v-if="isphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <!-- <br /> -->
                <!-- <p style="color: #A5A5A5">Email <span style="color: #EC1B23;">*</span></p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="email"
                    :class="{ 'custom-input': true }"
                    min="0"
                    :disabled="preview"
                  />
                </div> -->
              </div>
              <div class="col-lg">


                <p style="padding-top: 20px; color: #A5A5A5">Service Location <span style="color: #EC1B23;">*</span></p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="servicelocation"
                  style="width: 90%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
                  <el-option v-for="option in servicelocations" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>
              </div>
            </div>
            <br />
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

          <base-button v-if="preview == false" :disabled="buttondisabled" type="primary"
            v-on:click="handleDone()">Done</base-button>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <p
            :style="{ color: colors.primary }"
            style="cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";
import { Select, Option } from "element-ui";
import { colors } from "../../../components/colors.js";
import { Modal } from "../../../../src/components";
import { debounce } from "src/util/debounce";
import StatusModal from 'src/components/StatusModal.vue';
import { modal } from "src/components/variable.js";

export default {
  name: "AddUser",

  components: {
    StatusModal,
    Card,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      modal: modal,
      positionid: 0,
      preview: "",
      message: "",
      personnelid: "",
      flag: "",
      buttondisabled: false,
      email_unique: "",
      colors: colors,
      // modal: modal,
      showPassword: false,
      showPassword1: false,

      short: "",
      short1: "",
      showPasswordMismatch: "",
      companyid: "",
      companyname: "",
      companyregno: "",
      companregnoerrormsg: "",
      companynameerrormessage: "",
      companyaddress1: "",
      companyaddress2: "",
      companyaddress3: "",
      phonenumber: "",

      fullname: "",
      fullnameerrormsg: "",
      staffid: "",
      staffiderrormsg: "",
      isphoneno: "",
      phoneno: "",
      email: "",
      faxnumber: "",
      servicelocation: "",
      servicelocations: [],

      modals: {
        successModal: false,
        cancelModal: false,
        failedModal: false,
        infoModal: false,
        warningModal: false,
        successModal2: false,
        failedModal2: false,
      },
    };
  },
  methods: {
    redirect() {
      this.$router.push("/Users");
    },
    getServiceLocation() {
      this.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.servicelocations.push(obj);
          }
        }
      });
    },
    deletenewpersonnel(index) {
      this.personneldetails.splice(index, 1);
    },
    cancelPersonnel() {
      this.personnelid = "";
      this.modals.warningModal = false;
    },
    deletePersonnel() {
      this.modals.warningModal = false;
      console.log(this.personnelid);
      this.$http
        .delete(
          ":10001/api/v1/user-management/contractor/" +
          this.$route.params.id +
          "/personnel/" +
          this.personnelid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.successModal = true;
            this.getDetails(this.$route.params.id);
          }
        });
    },
    openmodaldelete(personnelid) {
      this.modals.warningModal = true;
      this.personnelid = personnelid;
    },
    getDetails(id) {
      this.personneldetails = [];
      this.$http
        .get(":10001/api/v1/user-management/personnel/" + id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            // this.companyid = response.contractor_id;
            // this.companyname = response.contractor_name;
            // this.companyregno = response.contractor_registration_no;
            // this.companyaddress1 = response.contractor_address.split(",")[0];
            // this.companyaddress2 = response.contractor_address.split(",")[1];
            // this.companyaddress3 = response.contractor_address.split(",")[2];

            // this.phonenumber = response.contractor_phone_number;

            // for (var i = 0; i < response.personnel.length; i++) {
            // let obj = {
            this.fullname = response.personnel_name;
            this.staffid = response.personnel_staff_id;
            this.personnelid = response.personnel_id;
            this.phoneno = response.personnel_phone_number;
            // this.email = response.personnel_email;
            this.faxnumber = response.personnel_fax_number;
            this.servicelocation = response.service_location_id;
            // };
            // this.personneldetails.push(obj);
            // }
          }
        });
    },
    addpersonnel() {
      this.personneldetails.push({
        fullname: "",
        staffid: "",
        phoneno: "",
        personnelid: 0,
      });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    getBack() {
      this.$router.push("/Users");
    },

    // saveDraft() {
    //   console.log("save draft");
    // },

    // getRoles() {
    //   this.selects.usertypes = [];

    //   this.$http.get(":10001/api/v1/setting/roles").then((res) => {
    //     if (!res.error) {
    //       let response = res.message;

    //       console.log("data here", response);

    //       for (var i = 0; i < response[0].Position.length; i++) {
    //         let obj = {
    //           label: response[0].Position[i].position_name,
    //           value: response[0].Position[i].position_id,
    //         };

    //         this.selects.usertypes.push(obj);
    //       }

    //       // this.selects.usertype = this.selects.usertypes[0].label;
    //     }
    //   });
    // },

    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },

    handleDone() {
      if (
        this.fullname != "" &&
        this.staffid != "" &&
        this.phoneno != "" &&
        // this.email != "" &&
        // this.faxnumber != "" &&
        this.servicelocation != ""
      ) {
        // construct array for personnel

        let obj = {
          // personnel_fax_number: this.faxnumber,
          personnel_name: this.fullname,
          personnel_staff_id: this.staffid.toString(),
          personnel_phone_number: this.phoneno,
          // personnel_email: this.email,
          service_location_id: this.servicelocation,
        };

        // console.log("datas", obj);

        if (this.flag == "add") {
          this.$http
            .post(":10001/api/v1/user-management/personnel", obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                this.message = response;
                this.modals.successModal = true;
                // this.modals.successModal2 = true;
                // this.message = response;
              } else {
                this.modals.failedModal = true;
              }
            }).
            catch(err => {
              this.message = err.response.data.message
              this.modals.failedModal = true;
            });
        } else {
          this.$http
            .put(":10001/api/v1/user-management/personnel/" + this.flag, obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                this.message = response;
                this.modals.successModal = true;

                setTimeout(() => {
                  this.$router.push("/Users");
                }, 2000);
              } else {
                this.modals.failedModal = true;
              }
            }).
            catch(err => {
              this.message = err.response.data.message
              this.modals.failedModal = true;
            });;
        }
      } else {
        this.message = "All information are required.";
        this.modals.infoModal = true;
      }
    },
    checkStaffID(staffid, index) {
      console.log(staffid);

      let obj = {
        personnel_staff_id: staffid,
      };
      this.$http
        .post(":10001/api/v1/helper/check-personnel-staffid", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            console.log(response);
            this.personneldetails[index].staffiderrormsg =
              response.error_message;
          }
          if (res.error) {
            // console.log(response.error_message);
            this.personneldetails[index].staffiderrormsg =
              response.error_message;
          }
        });
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    if (this.positionid == 2) {
      console.log("sinih");
      if (this.$route.params.viewflag == "preview") {
        this.preview = true;
      } else {
        this.preview = false;
      }
    } else {
      this.preview = false;
    }
    this.getServiceLocation();
    this.flag = this.$route.params.id;
    if (this.flag == "add") {
    } else {
      this.getDetails(this.$route.params.id);
    }
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    phoneno() {
      if (this.phoneno.length <= 7) {
        this.isphoneno = true;
      } else {
        this.isphoneno = false;
      }
    },
    companyname: debounce(function () {
      let obj = {
        company_name: this.companyname,
      };

      this.$http
        .post(":10001/api/v1/helper/check-company-name", obj)
        .then((res) => {
          let response = res.message;

          if (!res.error) {
            this.buttondisabled = false;
            this.companynameerrormessage = "";
          } else if (res.error) {
            this.buttondisabled = true;
            this.companynameerrormessage = response;
          } else {
            this.buttondisabled = false;
            this.companynameerrormessage = "";
          }
        });

      this.email_unique = "";
    }, 500),
    companyregno: debounce(function () {
      let obj = {
        company_reg_num: this.companyregno,
      };

      this.$http
        .post(":10001/api/v1/helper/check-company-reg", obj)
        .then((res) => {
          let response = res.message;

          if (!res.error) {
            this.buttondisabled = false;
            this.companregnoerrormsg = "";
          } else if (res.error) {
            this.buttondisabled = true;
            this.companregnoerrormsg = response;
          } else {
            this.buttondisabled = false;
            this.companregnoerrormsg = "";
          }
        });
    }, 500),
    personneldetails: {
      handler: function (val, oldVal) {
        for (var i = 0; i < this.personneldetails.length; i++) {
          //   console.log(val[i]);
          this.checkStaffID(this.personneldetails[i].staffid, i);
          if (val[i].fullname == "") {
            this.personneldetails[i].fullnameerrormsg = "required";
          } else {
            this.personneldetails[i].fullnameerrormsg = "";
          }
        }
      },
      deep: true,
    },
    //   let obj = {
    //     company_reg_num: this.companyregno,
    //   };

    //   this.$http
    //     .post(":10001/api/v1/helper/check-company-reg", obj)
    //     .then((res) => {
    //       let response = res.message;

    //       if (!res.error) {
    //         this.buttondisabled = false;
    //         this.companregnoerrormsg = "";
    //       } else if (res.error) {
    //         this.buttondisabled = true;
    //         this.companregnoerrormsg = response;
    //       } else {
    //         this.buttondisabled = false;
    //         this.companregnoerrormsg = "";
    //       }
    //     });

    // password() {
    //   if (this.password != this.confirmpassword && this.password.length < 8) {
    //     this.buttondisabled = true;
    //   }

    //   if (this.password == this.confirmpassword && this.password.length >= 8) {
    //     this.buttondisabled = false;
    //   }
    // },

    // confirmpassword() {
    //   if (
    //     this.password != this.confirmpassword &&
    //     this.confirmpassword.length < 8
    //   ) {
    //     this.message = "Password did not match";
    //     this.buttondisabled = true;
    //   }

    //   if (
    //     this.password == this.confirmpassword &&
    //     this.confirmpassword.length >= 8
    //   ) {
    //     this.message = "";
    //     this.buttondisabled = false;
    //   }
    // },
  },
};
</script>
<style>
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
